import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import BuyerProducts from "./pages/buyer/BuyerProducts";
import ProductDetail from "./pages/buyer/ProductDetail";
import ComparePage from "./pages/buyer/ComparePage";

import AdminRoutes from "./Routes/AdminRoutes";
import SellerRoutes from "./Routes/SellerRoutes";
import BuyerRoutes from "./Routes/BuyerRoutes";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [registerRole, setRegisterRole] = useState("SELLER");

  useEffect(() => {

    const openLogin = () => setShowLogin(true);

    window.addEventListener("openLogin", openLogin);

    return () => {
      window.removeEventListener("openLogin", openLogin);
    };

  }, []);

  return (
    <BrowserRouter>

      {/* NAVBAR */}
      <Navbar
        openLogin={() => setShowLogin(true)}
        openRegister={(role) => {
          setRegisterRole(role || "BUYER");
          setShowRegister(true);
        }}
      />

      {/* ROUTES */}
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/" element={<BuyerProducts />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/compare" element={<ComparePage />} />
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* MODULE ROUTES */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/seller/*" element={<SellerRoutes />} />
        <Route path="/buyer/*" element={<BuyerRoutes />} />

      </Routes>

      {/* FOOTER */}
      <Footer />

      {/* LOGIN MODAL */}
      {showLogin && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <Login
            closeModal={() => setShowLogin(false)}
            openRegister={(role) => {
              setShowLogin(false);
              setRegisterRole(role);
              setShowRegister(true);
            }}
          />
        </div>
      )}

      {/* REGISTER MODAL */}
      {showRegister && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <Register
            closeModal={() => setShowRegister(false)}
            role={registerRole}
          />
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
      />

    </BrowserRouter>
  );
}

export default App;